export const whitelabel = {
  plans: 'Paketi',
  managePlan: 'Upravljanje paketima',
  whitelabelCharges: 'Whitelabel Naknade',
  chargesOrTaxesConfiguration: 'Konfiguracija naknada/poreza',
  websitePlans: 'Planovi web stranice',
  whatsappPlansHeader: 'WhatsApp Planovi',
  addOnPlans: {
    createAddOnPlans: 'Kreiraj dodatne planove',
    checkoutYourCurrentMessage: 'Pregledajte svoje trenutne dodatne planove poruka i nove planove za svoje korisnike',
    choosePlanValidity: 'Izaberite trajanje plana',
    chooseValidity: 'Izaberite trajanje',
    oneYear: 'Jedna godina',
    billingCycle: 'Ciklus naplate',
    numberOfMessages: 'Broj poruka',
    pleaseEnterNumberOfMessages: 'Unesite broj poruka',
    setCurrency: 'Postavite valutu',
    select: 'Izaberi',
    inr: 'INR',
    usd: 'USD',
    cad: 'CAD',
    clearAll: 'Očisti sve',
    apply: 'Primijeni',
    currency: 'Valuta',
    amount: 'Iznos',
    validity: 'Trajanje',
    upgradePlan: 'Ažurirajte plan',
    addPlan: 'Dodaj plan',
    serialNumber: 'Redni broj',
    messages: 'Poruke',
    active: 'Aktivan',
    priceDetails: 'Detalji cijene',
    action: 'Akcija',
    addOnChanges: 'Dodatne naknade: ',
    perYear: 'godišnje',
    taxes: 'Porezi',
    placeholders: {
      enterNumberOfMesasges: 'Unesite broj poruka',
      enterAmount: 'Unesite iznos',
      enterValidity: 'Unesite trajanje',
      searchByMessages: 'Pretraži po porukama'
    },
    modal: {
      deleteAddOnsPlan: 'Izbriši dodatne planove',
      wantToDeleteThisAddOnsPlan: 'Jeste li sigurni da želite izbrisati ove dodatne planove?',
    }
  },
  charges: {
    addWhitelabelCharges: 'Dodajte WhiteLabel naknade',
    checkoutExistingCharges: 'Pregledajte postojeće naknade na različitim načinima plaćanja i dodajte nove Whitelabel naknade',
    currency: 'Valuta',
    chooseCurrency: 'Izaberite valutu',
    amountPerBotPerMonth: 'Iznos po botu mjesečno',
    cancel: 'Odustani',
    upgradeChanges: 'Ažurirajte naknade',
    addCharges: 'Dodajte naknade',
    serialNumber: 'Redni broj',
    action: 'Akcija',
    taxes: 'Porezi',
    placeholders: {
      enterAmountBotPerMonth: 'Unesite iznos bota mjesečno',
      searchByCurrency: 'Pretraži prema valuti',
    },
    modal: {
      deleteCharges: 'Izbriši naknade',
      wantToDeleteThisCharge: 'Jeste li sigurni da želite izbrisati ovu naknadu?',
    }
  },
  planManagement: {
    createNewPlans: 'Kreirajte nove planove',
    checkoutYourCurrentPlan: 'Pregledajte svoje trenutne planove i dodajte nove planove za svoje korisnike',
    choosePlan: 'Izaberite plan',
    selectPlan: 'Odaberite plan',
    baby: 'Mali',
    king: 'Kralj',
    displayName: 'Naziv za prikaz',
    messageLimit: 'Ograničenje poruka',
    enterAValidEmail: 'Unesite ispravnu e-poštu',
    setCurrency: 'Postavite valutu',
    select: 'Izaberi',
    inr: 'INR',
    usd: 'USD',
    cad: 'CAD',
    clearAll: 'Očisti sve',
    apply: 'Primijeni',
    perMonth: '/Mjesec',
    perYear: '/Godina',
    cancel: 'Odustani',
    upgradePlan: 'Ažurirajte plan',
    addPlan: 'Dodajte plan',
    serialNumber: 'Redni broj',
    plan: ' Plan',
    messages: 'Poruke',
    pricing: 'Cijena',
    actions: 'Akcije',
    perMonthText: 'Mjesečno',
    perYearText: 'Godišnje',
    placeholders: {
      enterDisplayName: 'Unesite prikazano ime',
      enterMessageLimit: 'Unesite ograničenje poruka',
      searchByPlanName: 'Pretraži po imenu plana ili porukama',
    },
    modal: {
      deletePlan: 'Izbriši plan',
      wantToDeleteThisBabyPlan : 'Brisanje Baby plana utjecat će na sve korisnike. Jeste li sigurni da želite izbrisati ovaj plan?',
      wantToDeleteThisPlan: 'Jeste li sigurni da želite izbrisati ovaj plan?',
    },
    appTooltip: {
      chooseYourPlanType: 'Izaberite vrstu plana',
      pleaseInputYourPlanDisplayName: 'Unesite prikazano ime svog plana',
      typeMessageLimitForCustomer: 'Unesite ograničenje poruka za korisnika',
      selectYourPreferredCurrencies: 'Izaberite svoje željene valute',
    }
  },
  taxesConfiguration: {
    addTaxes: 'Dodaj poreze',
    checkoutExistingTaxes: 'Pregledajte postojeće poreze na različitim načinima plaćanja i nove poreze',
    taxName: 'Naziv poreza',
    applicableOn: 'Primjenjivo na',
    choosePlans: 'Izaberite planove',
    chooseCurrency: 'Izaberite valutu',
    percentage: 'Postotak',
    cancel: 'Odustani',
    serialNumber: 'Redni broj',
    name: 'Ime',
    currency: 'Valuta',
    updateTaxes: 'Ažuriraj poreze',
    actions: 'Akcije',
    modal: {
      deleteTaxes: 'Izbriši poreze',
      wantToDeleteThisTax: 'Jeste li sigurni da želite izbrisati ove poreze?',
    },
    placeholders: {
      taxName: 'Naziv poreza',
      taxPercentage: 'Postotak poreza',
      searchByCurrency: 'Pretraži po valuti',
    }
  },
  whatsappPlans: {
    createNewPlans: 'Kreirajte nove planove',
    checkoutYourCurrentAndNewPlans: 'Pregledajte svoje trenutne planove i dodajte nove planove za svoje korisnike',
    choosePlan: 'Izaberite plan',
    selectPlan: 'Odaberite plan',
    baby: 'Mali',
    king: 'Kralj',
    displayName: 'Naziv za prikaz',
    messageLimit: 'Ograničenje razgovora',
    enterAValidMessageLimit: 'Unesite ispravno ograničenje razgovora',
    setCurrency: 'Postavite valutu',
    select: 'Izaberi',
    inr: 'INR',
    usd: 'USD',
    cad: 'CAD',
    clearAll: 'Očisti sve',
    apply: 'Primijeni',
    perMonth: '/Mjesec',
    perYear: '/Godina',
    cancel: 'Odustani',
    addPlan: 'Dodajte plan',
    serialNumber: 'Redni broj',
    plan: 'Plan',
    messages: 'Razgovori',
    pricing: 'Cijena',
    actions: 'Akcije',
    perMonthText: 'Mjesečno',
    perYearText: 'Godišnje',
    updatePlan: 'Ažurirajte plan',
    placeholders: {
      enterDisplayName: 'Unesite prikazano ime',
      enterMessageLimit: 'Unesite ograničenje razgovora',
      searchByPlanName: 'Pretraži po imenu plana ili razgovorima',
    },
    appTooltip: {
      typeMessageLimitForCustomer: 'Unesite ograničenje razgovora za korisnika',
      chooseYourPlanType: 'Izaberite vrstu plana',
      selectYourPreferredCurrencies: 'Izaberite svoje željene valute',
      pleaseInputYourPlanDisplayName: 'Unesite prikazano ime svog plana',
    },
    modal: {
      deletePlan: 'Izbriši plan',
      areYouSureYouWantToDeleteThisPlan: 'Jeste li sigurni da želite izbrisati ovaj plan?',
      wantToDeleteThisBabyPlan : 'Brisanje Baby plana utjecat će na sve korisnike. Jeste li sigurni da želite izbrisati ovaj plan?',
    }
  }
};

